export default $axios => {   
    return {
        async create(form) {  
            return await $axios.post('/simulator/simulation/generate', form);  
        },

        async get(query = '') { 
            return await $axios.get(`/simulator/simulation${query}`);  
        },

        async getByName(name) {
            const query = name != undefined ? `?db_schema=${name}` : '';

            return await $axios.get(`/simulator/history${query}`);  
        },

        async getById(id) {
            return await $axios.get(`/simulator/simulation/${id}`);  
        },

        async getComments(id) {
            return await $axios.get(`/simulator/simulation/${id}/comments`);  
        },

        async addComment(params) { 
            return await $axios.post(`/simulator/simulation/${params.id}/comment`, {
                comment: params.comment
            });
        }
    }; 
}; 
 